import VideoWithMeta from 'components/VideoWithMeta/VideoWithMetaPresentation'

export default VideoWithMeta
